import { ViteReactSSG } from "vite-react-ssg";
import { routes } from "./routes";
import "./index.css";
import "./i18n";

// Service worker unregister + cache purge — moved out of module top so the
// SSG Node process doesn't try to read `navigator` / `caches`. Runs only on
// the client during the ViteReactSSG setup callback.
function clearServiceWorkers() {
  if (typeof navigator === "undefined") return;
  if ("serviceWorker" in navigator) {
    navigator.serviceWorker
      .getRegistrations()
      .then((regs) => regs.forEach((r) => r.unregister()))
      .catch(() => {});
  }
  if (typeof window !== "undefined" && "caches" in window) {
    caches
      .keys()
      .then((keys) => keys.forEach((k) => caches.delete(k)))
      .catch(() => {});
  }
}

export const createRoot = ViteReactSSG({ routes }, ({ isClient }) => {
  if (isClient) clearServiceWorkers();
});
